import React, { useState } from "react";
import ImmoHeader from "../../immobilier/componnents/ImmoHeader";
import moment from "moment";
import { deepSearchFunction } from "../../../redux/actions/immobilierActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./savedSearches.css";
import mainAxios from "../../../redux/api/mainAxios";
import { closeModal, openModal } from "../../../redux/actions/modalActions";
import ConfirmationModal from "../../backOffice/components/ConfirmationModal";
import toast from "react-hot-toast";
import { UserData } from "../../../redux/actions/userAuthActions";
import EditSearchModal from "./EditSearchModal";

const SavedSearches = ({ savedSearches }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeMenuId, setActiveMenuId] = useState(null);

  // Ensure arrays are converted to string ID arrays like ["1", "2", ...]
  const normalizeIds = (arr) => {
    if (!Array.isArray(arr)) return [];
    return arr
      .map((item) => {
        if (item == null) return null;
        if (typeof item === 'object') {
          // support {id}, {value}, or raw object with numeric/string coercion
          const id = item.id ?? item.value ?? null;
          return id != null ? String(id) : null;
        }
        return String(item);
      })
      .filter((v) => v !== null);
  };

  const handleSearch = (search) => {
    const searchData = {
      // General section
      // nomRecherche: search.nomRecherche,
      usage: search.usage,
      lieu: normalizeIds(search.lieu),
      dispositif: search.dispositif,
      zone_fiscale: search.zone_fiscale,
      statutLot: search.statutLot,
      origine: search.origine,
      perimetere: search.perimetere,
      nouveaute_depuis: search.nouveaute_depuis,
      // Economic section
      budgetMin: search.budgetMin,
      budgetMax: search.budgetMax,
      prixM2Min: search.prixM2Min,
      prixM2Max: search.prixM2Max,
      rentabiliteMin: search.rentabiliteMin,
      honorairesMin: search.honorairesMin,
      // Lot section
      referenceLot: search.referenceLot,
      type: search.type,
      surfaceMin: search.surfaceMin,
      surfaceMax: search.surfaceMax,
      espaceTotalMin: search.espaceTotalMin,
      espaceTotalMax: search.espaceTotalMax,
      typologieLot: search.typologieLot,
      etage: search.etage,
      annexe: search.annexe,
      // Programme section
      programme: normalizeIds(search.programme),
      promoteur: normalizeIds(search.promoteur),
      label: search.label,
      mes_activites: search.mes_activites,
      allotement: search.allotement,
      offre_speciale: search.offre_speciale
    };
    try {
      // promoteur search
      dispatch(
        deepSearchFunction(
          searchData,
          "search",
          search.documentId,
          search.nomRecherche
        )
      );
    } catch (error) {
      console.error("Error during search:", error);
    } finally {
      navigate("/immobilier");
    }

    //saved search
  };

  const toggleMenu = (id, e) => {
    e.stopPropagation();
    setActiveMenuId(activeMenuId === id ? null : id);
  };

  const handleModify = (search, documentId, e) => {
    e.stopPropagation();

    // Transform lieu from array of objects to array of IDs
    const transformedSearch = {
      ...search,
      lieu: search.lieu ? search.lieu.map(location => location.id) : [],
      programme: search.programme ? search.programme.map(programme => programme.id) : [],
      promoteur: search.promoteur ? search.promoteur.map(promoteur => promoteur.id) : [],
    };
    dispatch(
      openModal({
        title: "Modifier la recherche",
        content: (
          <EditSearchModal searchData={transformedSearch} documentId={documentId} />
        ),
      })
    );
    setActiveMenuId(null);
  };

  const handleDeleteClick = (documentId, e) => {
    e.stopPropagation();
    dispatch(
      openModal({
        title: "Confirmation",
        content: (
          <ConfirmationModal
            message="Êtes-vous sûr de vouloir supprimer cet recherche ?"
            onConfirm={() => handleConfirmDelete(documentId)}
            onCancel={() => dispatch(closeModal())}
          />
        ),
      })
    );
  };
  const handleConfirmDelete = async (documentId) => {
    await mainAxios.delete(`/api/search-histories/${documentId}`);
    setActiveMenuId(null);
    toast.success("Recherche supprimée avec succès");
    dispatch(closeModal());
    dispatch(UserData());
  };
  const handleClickOutside = () => {
    if (activeMenuId) {
      setActiveMenuId(null);
    }
  };

  const [searchFilter, setSearchFilter] = useState("");

  // Handle search input changes

  return (
    <div onClick={handleClickOutside}>
      <ImmoHeader
        filterBtn={false}
        carte={false}
        lots={false}
        programmes={false}
        filterInput={searchFilter}
        setFilterInput={setSearchFilter}
        searchPlaceholder="Rechercher par nom de recherche..."
      />
      {/* Header */}
      <div className="table-searches-prog-header pink text-center mt-10 mb-10 ">
        <div className="table-cell">Nom de Recherche</div>
        <div className="table-cell">Date de la recherche</div>
        <div className="table-cell">Lieu</div>
        <div className="table-cell">Budget (min-max)</div>
        <div className="table-cell">Surface (min-max)</div>
        <div className="table-cell">Typologies</div>
        <div className="table-cell">Editer</div>
      </div>
      {/* Rows */}
      <div className="d-flex flex-column gap10 table-saved-search-row">
        {savedSearches.length > 0 ? (
          savedSearches
            .filter((search) => {
              // Search by nomRecherche (search name) instead of lieu
              const searchName = search.nomRecherche || "Sans nom";
              return (
                searchFilter === "" ||
                searchName.toLowerCase().includes(searchFilter.toLowerCase())
              );
            })
            .map((search) => (
              <div
                key={search.id}
                className=" tables-rows-searches-prog saved-searches-row "
                onClick={() => handleSearch(search)}
                style={{ cursor: "pointer" }}
              >
                <div className="text-center table-cell">
                  <div>{search.nomRecherche || "Sans nom"}</div>
                </div>
                <div className="text-center table-cell">
                  <div>{moment(search.createdAt).format("DD/MM/YYYY")}</div>
                </div>
                <div className="text-center table-cell">
                  <div>
                    {search.lieu && search.lieu.length > 0
                      ? search.lieu.length > 2
                        ? search.lieu.slice(0, 2).map((location) => location.name).join(", ") + "..."
                        : search.lieu.map((location) => location.name).join(", ")
                      : "Non mentionné"}
                  </div>
                </div>
                <div className="text-center table-cell">
                  <div>
                    {search.budgetMin
                      ? `${search.budgetMin} €`
                      : "Non mentionné"}{" "}
                    -{" "}
                    {search.budgetMax
                      ? `${search.budgetMax} €`
                      : "Non mentionné"}
                  </div>
                </div>
                <div className="text-center table-cell">
                  <div>
                    {search.surfaceMin || "Non mentionné"} -{" "}
                    {search.surfaceMax || "Non mentionné"}
                  </div>
                </div>
                <div className="text-center table-cell">
                  <div>{search.typologieLot || "Non mentionné"}</div>
                </div>
                <div className="dotsMenu" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="border-0 bg-none p-2"
                    onClick={(e) => toggleMenu(search.id, e)}
                  >
                    <img
                      src="./icons/dots-menu.svg"
                      alt="menu"
                      height={25}
                      width={25}
                    />
                  </button>
                  {activeMenuId === search.id && (
                    <div className="dots-menu-modal">
                      <div
                        className="dots-menu-item"
                        onClick={(e) =>
                          handleModify(search, search.documentId, e)
                        }
                      >
                        Modifier
                      </div>
                      <div
                        className="dots-menu-item"
                        onClick={(e) => handleDeleteClick(search.documentId, e)}
                      >
                        Supprimer
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))
        ) : (
          <div className="text-center">Aucune recherche enregistrée</div>
        )}
      </div>
    </div>
  );
};

export default SavedSearches;
